import { Navigate, Outlet, useLocation } from "react-router-dom";


function checkToken() {
    var now = new Date().getTime();
    var setupTime = parseInt(localStorage.getItem('setupTime'));
    
    if (setupTime !== null) {
        // Checking if the user is logged in or not...
        var eightHoursInMillis = 60 * 60 * 7000; 
        var timeDiff = now - setupTime;

        if (timeDiff > eightHoursInMillis) {
            console.log("Clearing localStorage data...");
            localStorage.clear();
            window.location.href = '/login'; 
        }
    } else {
        console.log("No setupTime found in localStorage.");
        // Handle the case where setupTime is not present in localStorage
    }
}

const AfterLogin = ({ children }) => {
    // const token = useSelector((state) => state?.auth?.token);
    const token = localStorage.getItem('ct_token');
    if (token) {
        return <Navigate to="/dashboard" />
    } else {
        return children;
    }
}

const Protected_routes = ({ children }) => {
    checkToken();
    // const token = useSelector((state) => state?.auth?.token);
    const token = localStorage.getItem('ct_token');
    if (!token) {
        return  window.location.href = '/login'; 
    } else {
        return children;
    }
}

const Required_auth = () => {
    checkToken();
    // const token = useSelector((state) => state?.auth?.token);
    const token = localStorage.getItem('ct_token');
    const location = useLocation();
    if (!token) {
        return  window.location.href = '/login'; 
    }
    if (token) {
        return <Outlet />
    }
    return <p>You are not authorized access this view</p>
}

const AdminLogout = () => {
    localStorage.clear();
    localStorage.removeItem("ct_token");
    localStorage.removeItem("userDetail");
    window.location.href = '/login'; 
  };
  



export { AfterLogin, Protected_routes, Required_auth,AdminLogout}